import { Box, Space, Title, Stack, Paper } from '@mantine/core';
import { GroupProgressBarItem } from 'components/GroupProgressBar/GroupProgressBarItem';
import { Enlistment } from 'models/user';
import { useTranslation } from 'react-i18next';

interface PatientPrescriptionsDrawerProps {
  groupList?: Enlistment[];
}

export const PatientPrescriptionsDrawer = ({ groupList }: PatientPrescriptionsDrawerProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Title order={4}>{t('patients_header_modal_title')}</Title>
      <Space mb={'md'} />
      {groupList &&
        groupList.map((group) => (
          <Stack key={`drawer-${group}`} my={'sm'}>
            <Paper radius={'md'} p={'md'} withBorder>
              <GroupProgressBarItem group={group} />
            </Paper>
          </Stack>
        ))}
    </Box>
  );
};
